import { CardFiled, ISliderItem } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IStatisticLineCardFieldProps {
   item: ISliderItem
   field: CardFiled
}
const StatisticLineCardField = ({item, ...props}: IStatisticLineCardFieldProps): JSX.Element => {
    return <div className='pe-statistic-line-card-field medallion-padder'>
        <div className="lc-label" >
            <span>
                { item.title }
            </span> 
            <span>
                {Math.round(item.value / 100 * props.field.max)}
            </span>
        </div>
        <div 
            className="lc-line-container"  
            style={{ height: props.field.weight, marginTop: props.field.weight, borderRadius:  (props.field.weight || 0)/2 }}
        >
            <div className="lc-line" style={{
                width: item.value + "%",
                height: props.field.weight
            }}>

            </div>
        </div>
    </div>
}
export default StatisticLineCardField